import { LOOM_SHARE_PAGE_REGEX_STR } from '../validate';
import { FULL_LO_URI, LOGIN } from '../../server/constants/routes';

export const getVideoURL = (videoID, url = FULL_LO_URI) => {
  return `${url}/share/${videoID}`;
};

export const getVideoAliasURL = (videoAliasID, url = FULL_LO_URI) => {
  return `${url}/a/${videoAliasID}`;
};

export const getOEmbedShareURL = (videoID, url = FULL_LO_URI) =>
  `${url}/v1/oembed?url=${global.encodeURIComponent(getVideoURL(videoID))}`;

export const getOEmbedAliasURL = (videoAliasID, url = FULL_LO_URI) =>
  `${url}/v1/oembed?url=${global.encodeURIComponent(
    getVideoAliasURL(videoAliasID)
  )}`;

export const getloginUrlWithRedirect = (
  redirect = null,
  loginCustomTitle = null,
  loginUrl = LOGIN
) => {
  const url = new URL(loginUrl);

  if (redirect) {
    url.searchParams.append('redirect_after', redirect);
  }

  if (loginCustomTitle) {
    url.searchParams.append('custom_title', loginCustomTitle);
  }

  return url.toString();
};

// pathname is of the form `/share/:videoId`, so pull out everything after
// the second slash and remove any query params after.
export const getVideoIdFromSharePageUrl = url => {
  if (!url) {
    return null;
  }

  const loomRegex = new RegExp(LOOM_SHARE_PAGE_REGEX_STR);
  const videoSharePageUrl = new URL(url);

  if (!loomRegex.test(url)) {
    return null;
  }

  return videoSharePageUrl?.pathname?.split('/')[2]?.split(/[^A-Za-z0-9]/)[0];
};
